export const Leftmenu = () => {
   const userGroupData = localStorage.getItem('groups');
   const roleID = localStorage.getItem("role_id");
   const menus = [
      {
         menu: "Dashboard",
         url: "/dashboard",
         container: "dashboard-container",
         ischild: false,
         icon: "fa fa-bar-chart",
         child: [],
      },
      {
         menu: "User Management",
         url: "#", // no direct URL, acts as dropdown
         container: "user-management-parent-container",
         ischild: true,
         icon: "fa fa-users",
         child: [
            {
               menu: "Production User Groups",
               url: "/user-group",
               icon: "fa fa-tags",
            },
            {
               menu: "User Details",
               url: "/user-management",
               icon: "fa fa-address-book",
            },
            {
               menu: "Customers",
               url: "/customers",
               icon: "fa fa-handshake-o",
            },
         ],
      },
      {
         menu: "Box Event Stages",
         url: "/events",
         container: "events-container",
         ischild: false,
         icon: "fa fa-sitemap",
         child: [],
      },
      {
         menu: "Job Specs",
         url: "/jobs",
         container: "specs-container",
         ischild: false,
         icon: "fa fa-address-card-o",
         child: [],
      },
      {
         menu: "Warehouse Management",
         url: "#", // no direct URL, acts as dropdown
         container: "inventory-management-parent-container",
         ischild: true,
         icon: "fa fa-home",
         child: [
            {
               menu: "Add Boxes",
               url: "/prep-queue",
               icon: "fa fa-cart-plus",
            },
            {
               menu: "Review & Assign Specs",
               url: "/review-and-assign-spec/all",
               icon: "fa fa-user-plus",
            },
            {
               menu: "Export Barcode Labels",
               url: "/wearhouse/all",
               icon: "fa fa-barcode",
            },
            {
               menu: "Update Delivery",
               url: "/update-delivery",
               icon: "fa fa-check-square-o",
            },
            {
               menu: "Disposition Boxes",
               url: "/disposition",
               icon: "fa fa-trash",
            },
         ],
      },


      // {
      //    menu: "Workflow",
      //    url: "/workflow",
      //    container: "workflow-container",
      //    ischild: false,
      //    icon: "fa fa-sitemap",
      //    child: [],
      // },
      // {
      //    menu: "Job Spec",
      //    url: "/jobs",
      //    container: "jobs-container",
      //    ischild: false,
      //    icon: "fa fa-briefcase",
      //    child: [],
      // },
      // {
      //    menu: "Job Event Logs",
      //    url: "/job-event-log",
      //    container: "job-event-uploads-container",
      //    ischild: false,
      //    icon: "fa fa-upload",
      //    child: [],
      // },
      {
         menu: "Box Processing",
         url: "#",
         container: "box-processing-container",
         ischild: true,
         icon: "fa fa-cubes",
         child: [{ menu: 'All Boxes', url: '/all-boxes', icon: 'fa fa-cube' },
         { menu: 'Box History', url: '/box-history', icon: 'fa fa-history' },
         ],
      },
      {
         menu: "Reports Management",
         url: "#",
         container: "reports-container",
         ischild: true,
         icon: "fa fa-print",
         child: [
            { menu: 'Job Inspection Report', url: '/job-inspection', icon: 'fa fa-calendar-check-o' },
            { menu: 'Box Progress Report', url: '/box-progress', icon: 'fa fa-th-large' },
            { menu: 'Monetization & Storage', url: '/monetization', icon: 'fa fa-archive' }
         ],

      },

      // {
      //    menu: "Barcode Generator",
      //    url: "/barcode",
      //    container: "barcode-container",
      //    ischild: false,
      //    icon: "fa fa-barcode",
      //    child: [],
      // },
      {
         menu: "Excel Logs",
         url: "/upload-log",
         container: "file-uploads-container",
         ischild: false,
         icon: "fa fa-upload",
         child: [],
      },
   ];

   let filteredMenus = [];

   if (roleID === "1" || roleID === "2") {
      filteredMenus = menus.filter((menu) => menu.menu !== "Job Event Logs");
   } else if (roleID === "3") {
      // Always add Dashboard
      filteredMenus = [menus.find((menu) => menu.menu === "Dashboard")];

      // Check if user belongs to group 1 → Add "Add Box To Spec"
      if (userGroupData?.split(",").includes("1")) {
         const inventoryMenu = menus.find((menu) => menu.menu == "Inventory Management");
         if (inventoryMenu) {
            const addBox = inventoryMenu.child.find((c) => c.menu == "Add Box To Spec");
            if (addBox) {
               filteredMenus.push({
                  ...addBox,
                  menu: "Add Box To Spec", // rename
                  container: "inventory-management-parent-container",
                  ischild: false, // make it a top-level menu
               });
            }
         }
      }

      // Always add "Job Specs"
      const boxProcessingMenu = menus.find((menu) => menu.menu === "Box Processing");
      if (boxProcessingMenu) {
         const allBoxes = boxProcessingMenu.child.find((c) => c.menu === "All Boxes");
         if (allBoxes) {
            filteredMenus.push({
               ...allBoxes,
               menu: "Process Boxes", // rename
               container: "process-boxes-container",
               ischild: false, // make it a top-level menu
            });
         }
      }

      // If group 1 → Add Excel Logs
      if (userGroupData?.split(",").includes("1")) {
         const uploadLogsMenu = menus.find((menu) => menu.menu === "Excel Logs");
         if (uploadLogsMenu) filteredMenus.push(uploadLogsMenu);
      }
   }

   return filteredMenus;
};
